export enum StatusField {
    UNKNOWN="0",
    YES="1",
    NO="2",
    NA="3"
}